export default function LiquidGlass({
  className = "",
  tag = "",
  children,
  childrenClassName = "",
  rounded = "",
  noGlass = false,
}) {
  const Tag = tag;

  return (
    <Tag className={`${className} relative`}>
      <div
        className={`${noGlass && "hidden"} absolute top-0 left-0 z-0 h-full w-full rounded-${rounded} transition-none shadow-[0_0_6px_rgba(0,0,0,0.03),0_2px_6px_rgba(0,0,0,0.08),inset_3px_3px_0.5px_-3px_rgba(255,255,255,0.9),inset_-3px_-3px_0.5px_-3px_rgba(255,255,255,0.85),inset_1px_1px_1px_-0.5px_rgba(255,255,255,0.6),inset_-1px_-1px_1px_-0.5px_rgba(255,255,255,0.6),inset_0_0_6px_6px_rgba(255,255,255,0.12),inset_0_0_2px_2px_rgba(255,255,255,0.06),0_0_12px_rgba(0,0,0,0.15)]`}
      />
      <div
        // backdrop-blur-lg removed from here:
        className={`${noGlass && "hidden"} absolute top-0 left-0 isolate -z-10 h-full w-full overflow-hidden rounded-${rounded} transition-none`}
      />
      {<div className={`${childrenClassName} z-10 transition-none`}>{children}</div>}
    </Tag>
  );
}
